var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_678)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_678",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H12.5V12.5H0.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.90001 3.49999C5.90001 3.16863 5.63139 2.89999 5.30001 2.89999C4.96864 2.89999 4.70001 3.16863 4.70001 3.49999V5.29999C4.70001 5.45913 4.76323 5.61174 4.87575 5.72426L6.07575 6.92425C6.31006 7.15855 6.68997 7.15855 6.92427 6.92425C7.15857 6.68995 7.15857 6.31005 6.92427 6.07573L5.90001 5.05147V3.49999Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0872 8.2382L12.3242 11.4758C12.3799 11.5315 12.4242 11.5976 12.4544 11.6704C12.4846 11.7432 12.5001 11.8212 12.5001 11.9C12.5001 11.9788 12.4846 12.0568 12.4544 12.1296C12.4242 12.2024 12.3799 12.2685 12.3242 12.3242C12.2686 12.3801 12.2025 12.4245 12.1297 12.4548C12.0569 12.4851 11.9788 12.5006 11.9 12.5006C11.8212 12.5006 11.7431 12.4851 11.6703 12.4548C11.5975 12.4245 11.5314 12.3801 11.4758 12.3242L8.2382 9.0872C7.39922 9.74318 6.36497 10.0997 5.3 10.1C2.6534 10.1 0.5 7.9466 0.5 5.3C0.5 2.6534 2.6534 0.5 5.3 0.5C7.9466 0.5 10.1 2.6534 10.1 5.3C10.1001 6.36503 9.74348 7.3994 9.0872 8.2382ZM5.3 1.7C3.3146 1.7 1.7 3.3146 1.7 5.3C1.7 7.2854 3.3146 8.9 5.3 8.9C7.2854 8.9 8.9 7.2854 8.9 5.3C8.9 3.3146 7.2854 1.7 5.3 1.7Z",
    fill: "#155EEF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/search-blue.d0c0fd23b851bce1947a2f885eed4fa5.svg";
export { ForwardRef as ReactComponent };